import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { Button, CardMedia, Typography } from '@mui/material';
import i18next from 'i18next';
import translate from './../../assets/translate/OIP.jpg';
import translate_en from './../../assets/translate/american-flag-usa-flag-png.png';

export function TransLang() {
    const { i18n } = useTranslation();
    const lng = i18next.language;

    const toggleLanguage = () => {
        const otherLng = lng === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(otherLng);
    };

    return (
        <Button
            sx={{
                borderRadius: 999,
                px: 2,
                py: 0.3,
                minWidth: 'auto',
                borderColor: (theme) => 'rgba(255,255,255,0.6)',
                color: '#FFFFFF',
                textTransform: 'none',
                fontSize: 13,
                fontWeight: 500,
                '&:hover': {
                    borderColor: '#FFFFFF',
                    backgroundColor: 'rgba(15,23,42,0.12)',
                },
            }}
            onClick={toggleLanguage}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: lng === 'ar' ? 'row-reverse' : 'row',
                    gap: 0.8,
                }}
            >
                {/* كان هنا IconButton وهو سبب تداخل الأزرار، استبدلناه بـ Box عادي */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 25,
                        color: 'inherit',
                        p: 0,
                    }}
                >
                    <CardMedia
                        component="img"
                        alt="tr"
                        loading="eager"
                        fetchpriority="high" // الحروف الصغيرة حتى لا يعطي تحذير React
                        decoding="async"
                        src={lng === 'en' ? translate : translate_en}
                        sx={{ width: 30, height: 20 }}
                    />
                </Box>
                <Typography fontWeight={600}>
                    {lng === 'en' ? 'العربية' : 'English'}
                </Typography>
            </Box>
        </Button>
    );
}
